import type { AdminTenant } from '@/api/models';
import type { FilterableSelectOption } from './FilterableSelect';

/**
 * One combobox option per tenant: the name leads, the code and the tag set
 * ride along as the secondary line, and the same three surfaces feed the
 * type-to-filter matching (name, code and any `key:value` tag text). Shared
 * by every tenant-picking combobox so a tenant reads the same everywhere.
 */
export function tenantToOption(tenant: AdminTenant): FilterableSelectOption {
  const tagTexts = (tenant.tags ?? []).map((tag) => `${tag.key}:${tag.value}`);
  return {
    value: tenant.code,
    label: tenant.name,
    secondary: [tenant.code, ...tagTexts].join(' · '),
    keywords: tagTexts.flatMap((text) => text.split(':')),
  };
}
